import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ShieldCheck } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const renderBulletLink = (to, label) => (
    <li className="flex items-center gap-2 text-xs text-text-secondary hover:text-brand-red cursor-pointer group">
      {/* Small helper square icon */}
      <div className="w-1.5 h-1.5 bg-text-muted group-hover:bg-brand-red transition-colors shrink-0" />
      <Link to={to} className="transition-colors duration-200">
        {label}
      </Link>
    </li>
  );

  return (
    <footer className="bg-neutral-surface-footer border-t border-border-light text-text-secondary">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Company Info */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center">
            <img
              src="https://assets.auxodev.dk/assets/3c12e69c-355b-4bf8-827c-6379a757f0e7/skals-vognmandsforretning-logo.png"
              alt="Skals Vognmandsforretning - Vognmand i Skals, Viborg og Skive"
              className="h-12 w-auto object-contain"
            />
          </div>
          <p className="text-xs text-text-secondary leading-relaxed">
            Professionel vognmandskørsel, containerservice og krankørsel med over 30 års erfaring. Vi leverer stabil service og pålidelige løsninger til både private og erhverv.
          </p>
          <div className="flex items-center gap-2 text-[11px] text-text-secondary bg-white p-3 border border-border-light">
            <ShieldCheck className="h-4 w-4 text-brand-red shrink-0" />
            <span>Medlem af ITD International Transport Danmark</span>
          </div>
        </div>

        {/* Services Links */}
        <div>
          <h3 className="text-text-primary font-bold text-xs uppercase tracking-wider mb-4">
            Vi tilbyder
          </h3>
          <ul className="space-y-2.5">
            {renderBulletLink('/vognmand', 'Vognmandskørsel')}
            {renderBulletLink('/grus-og-sten', 'Sand, grus og sten')}
            {renderBulletLink('/containerkoersel', 'Containerkørsel')}
            {renderBulletLink('/krankoersel', 'Krankørsel')}
            {renderBulletLink('/udlejning-af-maskiner', 'Udlejning af små maskiner')}
            {renderBulletLink('/arbejde-med-gummiged', 'Arbejde med gummiged')}
            {renderBulletLink('/haveflis', 'Haveflis')}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-text-primary font-bold text-xs uppercase tracking-wider mb-4">
            Hurtige links
          </h3>
          <ul className="space-y-2.5">
            {renderBulletLink('/profil', 'Profil & Historie')}
            {renderBulletLink('/vores-lastbiler', 'Vores lastbiler')}
            {renderBulletLink('/kontakt', 'Kontakt os')}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-text-primary font-bold text-xs uppercase tracking-wider mb-4">
            Kontaktoplysninger
          </h3>
          <ul className="space-y-3.5 text-xs text-text-secondary">
            <li className="flex items-start gap-2.5">
              <MapPin className="h-4 w-4 text-brand-red shrink-0 mt-0.5" />
              <span>
                Industriparken 5<br />
                8832 Skals
              </span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 text-brand-red shrink-0" />
              <a href="tel:40458650" className="hover:text-brand-red transition-colors whitespace-nowrap">
                40 45 86 50
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 text-brand-red shrink-0" />
              <a href="mailto:evskals@gmail.com" className="hover:text-brand-red transition-colors whitespace-nowrap">
                evskals@gmail.com
              </a>
            </li>
            <li className="text-[11px] text-text-muted pt-2 border-t border-border-light">
              CVR nr.: 13530092
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="h-12 bg-[#eceef0] border-t border-border-light flex items-center justify-between text-[10px] text-text-muted px-4 sm:px-6 lg:px-8">
        <button className="hover:text-brand-red transition-colors cursor-pointer">
          Cookie-indstillinger
        </button>
        <p>© {currentYear} Skals Vognmandsforretning. Alle rettigheder forbeholdes.</p>
      </div>
    </footer>
  );
}
